export default function getScreenResolution(isMobile) {
  if (!!isMobile) {
    return window.screen.width * window.devicePixelRatio + "x" + window.screen.height * window.devicePixelRatio;
  } else {
    return window.screen.width + "x" + window.screen.height;
  }
}
